<template>
  <HubContainer id="companySuperAdminHub">

    <template v-if="atLeastDistributor">
      <HubSection icon="icon/hub/company.svg"
                  :title="$t('settings_admin.company')"
                  :description="$t('settings_admin.description')"
                  :buttonAction="goToCompany">
      </HubSection>

      <HubSection icon="icon/hub/services.svg" v-if="atLeastSuperAdmin"
                  :title="$t('services.title')"
                  :description="$t('services.company_description')"
                  :buttonAction="goToServices">
      </HubSection>

      <HubSection icon="icon/hub/subscription.svg" v-if="atLeastSuperAdmin"
                  :title="$t('paid_features.title')"
                  :description="$t('paid_features.description')"
                  :buttonAction="goToPaidFeatures">
      </HubSection>

      <HubSection icon="icon/hub/external-pos.svg"
                  :title="$t('companies.settings.externalPos')"
                  :description="$t('companies.settings.externalPos_description')"
                  :buttonAction="goToExternalPosHub">
      </HubSection>

      <HubSection icon="icon/hub/global-settings.svg"
                  :title="$t('advanced_navigation.global_settings')"
                  :description="$t('advanced_navigation.global_settings_company_description')"
                  :buttonAction="goToGlobalSettingsHub">
      </HubSection>

      <HubSection icon="icon/hub/support.svg"
                  :title="$t('advanced_navigation.support')"
                  :description="$t('advanced_navigation.support_description')"
                  :buttonAction="goToSupportHub">
      </HubSection>

      <HubSection icon="icon/hub/power-inventory.svg"
                  :title="$t('inventory_power_user.title')"
                  :description="$t('inventory_power_user.description')"
                  :buttonAction="goToPowerUser">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "branchSuperAdminHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = this.getContextName;
      this.$store.state.pageIcon = "/icon/nav/revenue-center.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      getContextName() {
        if (this.branch && this.company) {
          return this.company.name;
        }
        return "";
      }
    },

    methods: {
      goToCompany() {
        this.$router.push(this.$router.buildContext("/company/edit"));
      },
      goToServices() {
        this.$router.push(this.$router.buildContext("/company/services"));
      },
      goToPaidFeatures() {
        this.$router.push(this.$router.buildContext("/company/paid-features"));
      },
      goToExternalPosHub() {
        this.$router.push(this.$router.buildContext("/external-pos-hub"));
      },
      goToGlobalSettingsHub() {
        this.$router.push(this.$router.buildContext("/company/global-settings-hub"));
      },
      goToSupportHub() {
        this.$router.push(this.$router.buildContext("/company/support-hub"));
      },
      goToPowerUser() {
        this.$router.push(this.$router.buildContext("/inventory-power-user"));
      },
    }
  }
</script>